<script setup lang="ts">
import { computed } from "vue";
import qrcode from "qrcode-generator";

/** A QR code drawn as SVG squares, for links a phone camera opens (rehearsal, two-step setup). */
const props = withDefaults(
  defineProps<{ value: string; size?: number; label: string }>(),
  { size: 200 },
);
const modules = computed(() => {
  const qr = qrcode(0, "M");
  qr.addData(props.value, "Byte");
  qr.make();
  const n = qr.getModuleCount();
  const cells: Array<[number, number]> = [];
  for (let r = 0; r < n; r += 1)
    for (let c = 0; c < n; c += 1) if (qr.isDark(r, c)) cells.push([c, r]);
  return { n, cells };
});
</script>
<template>
  <svg
    class="qr-code"
    role="img"
    :aria-label="label"
    :width="size"
    :height="size"
    :viewBox="`-2 -2 ${modules.n + 4} ${modules.n + 4}`"
    shape-rendering="crispEdges"
  >
    <rect
      x="-2"
      y="-2"
      :width="modules.n + 4"
      :height="modules.n + 4"
      fill="#fff"
    />
    <path
      fill="#111b21"
      :d="modules.cells.map(([x, y]) => `M${x} ${y}h1v1h-1z`).join('')"
    />
  </svg>
</template>
